import Container from '@mui/material/Container';

import { paths } from 'src/routes/paths';

import { useSettingsContext } from 'src/components/settings';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';

import PackagingDamageDispatchNewForm from '../packaging-damage-dispatch-new-form';

export default function PackagingDamageDispatchCreateView() {
  const settings = useSettingsContext();

  return (
    <Container maxWidth={settings.themeStretch ? false : 'lg'}>
      <CustomBreadcrumbs
        heading="Create a new damage dispatch"
        links={[
          {
            name: 'Damage Dispatch',
            href: paths.dashboard.packagingDamageDispatch.root,
          },
          { name: 'Create a new damage dispatch' },
        ]}
        sx={{
          mb: { xs: 3, md: 5 },
        }}
      />

      <PackagingDamageDispatchNewForm />
    </Container>
  );
}
